import Yup from '_zari/validation/_yup'

export default Yup.object().shape({
  fechaInicio: Yup.string().required(),
  fechaFin: Yup.string().required()
})
